/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/undefined/ngm-portal-jws/public/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "gDIR");
/******/ })
/************************************************************************/
/******/ ({

/***/ "gDIR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__("pU8g");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LSG_KEY_TIMESTAMP = '__ng_quark_popup_v2';
var LSG_KEY_TIMES = '__ng_quark_popup_time_v2';
var LSG_KEY_INS = '__ng_quark_popup_install';
var LSG_KEY_DONT_TIPS = '__ng_quark_popup_dont_tips_v2';
var MAX_TIME = 3;

var NG_URL = 'https://www.9game.cn/yunyou/';

var QuarkPopup = function () {
  function QuarkPopup() {
    _classCallCheck(this, QuarkPopup);

    this.Init();
  }

  _createClass(QuarkPopup, [{
    key: 'isNextDay',
    value: function isNextDay() {
      var prevShowTime = window.localStorage.getItem(LSG_KEY_TIMESTAMP);
      if (prevShowTime) {
        var nowTime = new Date();
        var prevTime = new Date(Number(prevShowTime));

        var now = nowTime.getTime();
        if (now >= Number(prevShowTime)) {
          var prevYear = prevTime.getFullYear();
          var prevMonth = prevTime.getMonth();
          var prevDate = prevTime.getDate();
          var nowYear = nowTime.getFullYear();
          var nowMonth = nowTime.getMonth();
          var nowDate = nowTime.getDate();

          if (nowYear == prevYear) {
            if (nowMonth == prevMonth) {
              if (nowDate > prevDate) {
                return true;
              } else if (nowDate <= prevDate) {
                return false;
              }
            } else if (nowMonth > prevMonth) {
              return true;
            } else if (nowMonth < prevMonth) {
              return false;
            }
          } else if (nowYear > prevYear) {
            return true;
          } else if (nowYear < prevYear) {
            return false;
          }
        } else {
          return false;
        }
      } else {
        return true;
      }
    }
  }, {
    key: 'isNextTime',
    value: function isNextTime() {
      var prevShowTime = window.localStorage.getItem(LSG_KEY_TIMESTAMP);
      if (prevShowTime) {
        var nowTime = new Date();
        var now = nowTime.getTime();
        var diff = now - Number(prevShowTime);

        if (diff >= TIMES_DELAY * 1000) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    }
  }, {
    key: 'popupShow',
    value: function popupShow() {
      this.popupDom.classList.add('entry');
      this.popupDom.classList.remove('hide');
    }
  }, {
    key: 'popupHide',
    value: function popupHide() {
      this.popupDom.classList.remove('entry');
      this.popupDom.classList.add('hide');
    }
  }, {
    key: 'autoShow',
    value: function autoShow() {
      this.popupShow();
      window.localStorage.setItem(LSG_KEY_TIMESTAMP, Date.now());
      var getTimes = window.localStorage.getItem(LSG_KEY_TIMES);
      window.localStorage.setItem(LSG_KEY_TIMES, getTimes ? Number(getTimes) + 1 : 1);
      var miaonwanUrl = $('.JS_QAK_D').data('miaowan') || NG_URL;
      window.__APLUS_REPORT__ && window.__APLUS_REPORT__.record('cdgpopup_exp', 'exp', {
        styleType: miaonwanUrl == NG_URL ? 'homepage' : 'gamepage',
        game_ch: this.ch
      });
    }
  }, {
    key: 'clickDown',
    value: function clickDown() {

      var miaonwanUrl = $('.JS_QAK_D').data('miaowan') || NG_URL;
      window.__APLUS_REPORT__ && window.__APLUS_REPORT__.record('cdgpopup_clk', 'clk', {
        target_url: miaonwanUrl,
        ck_url: 'link',
        styleType: miaonwanUrl == NG_URL ? 'homepage' : 'gamepage',
        game_ch: this.ch
      });
      window.open(miaonwanUrl);
    }
  }, {
    key: 'clickJump',
    value: function clickJump() {
      var cdgUrl = $('.JS_QAK_GZ').data('cdgurl') || 'https://www.9game.cn/yunyou/';
      window.__APLUS_REPORT__ && window.__APLUS_REPORT__.record('cdgpopupjump_clk', 'clk', {
        target_url: cdgUrl,
        ck_url: 'link',
        styleType: cdgUrl == NG_URL ? 'homepage' : 'gamepage',
        game_ch: this.ch
      });
      window.open(cdgUrl);
    }
  }, {
    key: 'Init',
    value: function Init() {
      var _this = this;

      this.popupDownDom.addEventListener('click', function () {
        _this.clickDown();
      });
      this.popupGZJump.addEventListener('click', function () {
        _this.clickJump();
      });

      this.popupCloseDom.addEventListener('click', function () {
        _this.popupHide();
        window.__APLUS_REPORT__ && window.__APLUS_REPORT__.record('qak_close_clk', 'clk', {
          target_url: 'none'
        });
      });

      this.autoShow();
    }
  }, {
    key: 'popupDom',
    get: function get() {
      return document.querySelector('.qak_popup');
    }
  }, {
    key: 'popupDownDom',
    get: function get() {
      return document.querySelector('.JS_QAK_D');
    }
  }, {
    key: 'popupCloseDom',
    get: function get() {
      return document.querySelector('.JS_QAK_CL');
    }
  }, {
    key: 'popupGZJump',
    get: function get() {
      return document.querySelector('.JS_QAK_GZ');
    }
  }, {
    key: 'ch',
    get: function get() {
      return $('.qak_popup').data('ch') || 'none';
    }
  }]);

  return QuarkPopup;
}();

new QuarkPopup();

/***/ }),

/***/ "pU8g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

/******/ });


// WEBPACK FOOTER //
// js/pc_quark_popup/index.b221f7b8.js